import {TryPerform, Delivered} from "@/enums/perform.type";

export default class {
    _id;
    _uid;
    _client;
    _area;
    _region;
    _pagesCount;
    _address;
    _receiver;
    _createdOn;
    _postPackage;
    _printPackage;
    _perform;
    _isExpress;
    _postIndex;
    _transfer;


    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get uid() {
        return this._uid;
    }

    set uid(value) {
        this._uid = value;
    }

    get client() {
        return this._client;
    }

    set client(value) {
        this._client = value;
    }

    get area() {
        return this._area;
    }

    set area(value) {
        this._area = value;
    }

    get region() {
        return this._region;
    }

    set region(value) {
        this._region = value;
    }

    get pagesCount() {
        return this._pagesCount;
    }

    set pagesCount(value) {
        this._pagesCount = value;
    }

    get address() {
        return this._address;
    }

    set address(value) {
        this._address = value;
    }

    get receiver() {
        return this._receiver;
    }

    set receiver(value) {
        this._receiver = value;
    }

    get createdOn() {
        return this._createdOn;
    }

    set createdOn(value) {
        this._createdOn = value;
    }

    get printPackage() {
        return this._printPackage;
    }

    set printPackage(value) {
        this._printPackage = value;
    }

    get postPackage() {
        return this._postPackage;
    }

    set postPackage(value) {
        this._postPackage = value;
    }

    get perform() {
        return this._perform;
    }

    set perform(value) {
        this._perform = value;
    }

    get transfer() {
        return this._transfer;
    }

    set transfer(value) {
        this._transfer = value;
    }

    get isExpress() {
        return this._isExpress
    }

    set isExpress(value) {
        this._isExpress = value
    }


    // computed properties
    get isPerformedTry() {
        return this.isPerformed && this._perform.performType === TryPerform
    }

    get isPerformedNotTry() {
        return this.isPerformed && this._perform.performType !== TryPerform
    }

    get isPerformedNotDelivered() {
        return this.isPerformed && this._perform.performType !== Delivered
    }

    get isPerformedDelivered() {
        return this.isPerformed && this._perform.performType === Delivered
    }

    get isPerformed() {
        return !!this._perform
    }

    get isPrinted() {
        return !!this._printPackage
    }

    get isPacked() {
        return !!this._postPackage
    }

    get isPostIndexed() {
        return !!this._postIndex
    }

    get isTransferNotified() {
        return !!this._transfer && this._transfer.isNotified === true
    }

    get isTransferCompleted() {
        return !!this._transfer && this._transfer.isCompleted === true
    }

    get allowDeliveryPerform() {
        return this.isPacked && (!this._perform || this._perform.performType !== Delivered)
    }

    get allowFailedPerform() {
        return this.isPacked && (!this._perform || this._perform.performType === TryPerform)
    }

    get allowTryPerform() {
        return !this._perform && this.isPacked
    }

    get allowUnsetPostPackage() {
        return !this._perform && this.isPacked;
    }

    get fullAddress() {
        return `${this.region.name} ${this.area.name} ${this.address}`
    }

    get postIndex() {
        return this._postIndex;
    }

    set postIndex(value) {
        this._postIndex = value;
    }

}
